<page-toolbar [pageActions]="pageActions" [title]="'customerWizard.title' | translate"></page-toolbar>

<div *ngIf="!!isLoading" class="loader"><mat-spinner></mat-spinner></div>

<page-content *ngIf="!isLoading">
  <ng-container *ngFor="let field of smartInputFields">
    <smart-input [(model)]="wizardData" [key]="field.key" [class]="field.class" [translationPrefix]="field.translationPrefix" (onChange)="field?.change ? field.change() : null">
      <div *ngIf="errors.includes(field.key)" class="error">{{ 'customerWizard.error.fieldEmpty' | translate }}</div>
    </smart-input>
  </ng-container>
  <mat-card appearance="outlined">
    <mat-card-content>
      <h2>
        <span>{{'customerWizard.backendUsers' | translate}}</span>
        <button (click)="addBackendUser()" color="primary" id="add" mat-fab>
          <mat-icon>add</mat-icon>
        </button>
      </h2>
      <div class="backend-user-list">
        <div *ngFor="let user of wizardData.backendUsers; let i = index">
          <div>
            <mat-form-field>
              <mat-label>{{'customerWizard.mail' | translate}}</mat-label>
              <input [(ngModel)]="user.mail" matInput>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{'customerWizard.firstName' | translate}}</mat-label>
              <input [(ngModel)]="user.firstName" matInput>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{'customerWizard.lastName' | translate}}</mat-label>
              <input [(ngModel)]="user.lastName" matInput>
            </mat-form-field>
            <button (click)="wizardData.backendUsers.splice(i, 1)" mat-icon-button><mat-icon>delete</mat-icon></button>
          </div>
          <div class="error" *ngIf="alreadyExistingProfiles.includes(user.mail)">{{ 'customerWizard.error.emailAlreadyExists' | translate }}</div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-content>
      <h2>
        <span>{{'customerWizard.apps' | translate}}</span>
        <button (click)="addApplication()" color="primary" id="addApp" mat-fab><mat-icon>add</mat-icon></button>
      </h2>
      <div *ngFor="let app of wizardData?.apps; let i = index" class="app">
        <div class="text">
          <span class="title">{{app.title}}</span><span> - {{'customerWizard.appTypes.' + app.type | translate}}</span>
        </div>
        <button (click)="editApplication(app, i)" mat-icon-button><mat-icon>edit</mat-icon></button>
        <button (click)="wizardData.apps.splice(i, 1)" mat-icon-button><mat-icon>delete</mat-icon></button>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="button-right-container">
    <button (click)="execute()" class="ibexfusion-raised-button" mat-button>{{'customerWizard.execute' | translate}}</button>
  </div>
</page-content>
